import comp from "./SendAlertMessageModal";
export default comp;
